import React, { useState, useEffect } from 'react';
import styles from './index.module.scss'
import More from '../../static/images_ae/moreArrow.png';
import tool_top_banner from '../../static/images_ae/alkReport/tool_top_banner.png';
import tool_purple_pencil from '../../static/images_ae/alkReport/tool-purple-pencil.png';
import tool_purple_all from '../../static/images_ae/alkReport/tool-purple-all.png';
import icon_more from '../../static/images_ae/alkTest/more.png';
import no_result from '../../static/images_ae/alkAsk/no_result.png';
import icon_medicine from '../../static/images_ae/alkAsk/icon_medicine.png';
import { ApiCore } from '../../api/index';
import { Toast, Popup } from 'antd-mobile-v5';
import { withRouter } from 'react-router-dom';

const api = new ApiCore();
const AeTestTools = (props: any) => {
    const savedUrlParam = localStorage.getItem('OriginUrlParam') || null;
    const shoppingParams = JSON.parse(JSON.parse(savedUrlParam)?.data || null) || ''

    const [tagList, setTagList] = useState<any>([])

    const [commonTagList, setCommonTagList] = useState<any>([])

    const [isCommonTag, setIsCommonTag] = useState<any>(true)

    const [alkTagList, setAlkTagList] = useState<any>([])

    const [questionnaireList, setQuestionnaireList] = useState([])

    const [questionnaireTypeList, setQuestionnaireTypeList] = useState([])

    const [typeEnumsArr, setTypeEnumsArr] = useState([])

    const [inType, setInType] = useState<any>(null)

    const [listReady, setListReady] = useState(false)

    const [visible, setVisible] = useState(false)
    
    const [dialogHasSelected, setDialogHasSelected] = useState(false)

    useEffect(() => {
        window.document.title = '自测量表';
        initData();
    }, [])

    useEffect(() => {
        const _item = commonTagList.filter((item: any) => ((item.isMore && item.active) || (item.bothHas && item.active)));
        setDialogHasSelected((_item && _item.length > 0));
        setTimeout(() => {
            const scrollEl : any = document.getElementById('edc_wechat_alk_tool_nav_scroll');
            const scrollTarget : any = document.getElementById('edc_wechat_alk_tool_nav');
            if (scrollEl && scrollTarget) {
                try {
                    // scrollEl.scrollLeft = scrollTarget?.offsetLeft - 16;
                    scrollEl.scrollTo(scrollTarget?.offsetLeft - 16, 0);
                } catch (error) {
                }
            }
        }, 500)
        // 会导致空白问题 ↓
        // setTimeout(() => {
        //     const _scrollEl = document.getElementById('edc_wechat_alk_tool_nav');
        //     // _scrollEl && _scrollEl.scrollIntoView({behavior: "smooth", block: "end", inline: "start"});
        //     _scrollEl && _scrollEl.scrollIntoView({behavior: "smooth", inline: "start"});
        // }, 500)
    }, [commonTagList])

    const initData = async () => {
        const typeArr = await initTypeEnums();
        setTypeEnumsArr(typeArr);
        initLists({}, typeArr);
        initConfig();
    }

    const initLists = (param?: any, typeArr?: any) => {
        let enumsArr = typeArr || typeEnumsArr;
        const _mParam = param || {};
        api.getQuestionnaireLists(_mParam).then((res: any) => {
            if (res.code == 0) {
                if (!_mParam.symptomCode && enumsArr && enumsArr.length > 0) {
                    setInType(true);
                    let enumsList:any = [];
                    let qList = {};
                    (res.data || []).forEach((vv: any) => {
                        if (qList[vv.type]) {
                            qList[vv.type].push(vv);
                        } else {
                            qList[vv.type] = [vv];
                        }
                    });
                    let index = 0;
                    enumsArr.forEach((vv: any, ii: number) => {
                        if (qList[vv.code]) {
                            if (qList[vv.code][0]) {
                                qList[vv.code][0].typeName = vv.name;
                            }
                            enumsList.push(qList[vv.code]);
                        }
                    });
                    setQuestionnaireTypeList(enumsList || []);
                } else {
                    setInType(false);
                }
                setQuestionnaireList(res.data || []);
                setListReady(true);
            }
        });
    }

    const initConfig = () => {
        api.getQuestionnaireConfig().then((res: any) => {
            if (res.code == 0) {
                const _data = res.data?.positionSymptoms;
                const _commonTagList:any = [{
                    code: '',
                    name: '全部',
                    active: true,
                    countNum: res.data?.totalNum
                }];
                const _list = [];
                const _listMap = {};
                let _count = -1;
                _data.forEach((v: any) => {
                    if (!_listMap[v.positionCode]) {
                        _count++;
                        v.index = _count;
                        _listMap[v.positionCode] = [v];
                    } else if (_listMap[v.positionCode]) {
                        v.index = _count;
                        _listMap[v.positionCode] = [..._listMap[v.positionCode], v]
                    }
                    if (v.isTop) {
                        _commonTagList.push(v);
                    }
                });
                for (const _key in _listMap) {
                    if (Object.prototype.hasOwnProperty.call(_listMap, _key)) {
                        const _element = _listMap[_key];
                        _list[_element[0].index] = _element;
                    }
                }
                setCommonTagList(_commonTagList);
                setTagList(_list);
            }
        });
    }

    const initTypeEnums = () => {
        return new Promise<any>((resolve, reject) => {
            api.getQuestionnaireTypeEnums({}).then((res: any) => {
                if (res.code == 0) {
                    resolve(res.data)
                } else {
                    resolve([])
                }
            })
        })
    }

    const setOrginCommonTags = () => {
        let _commonTagList: any = JSON.parse(JSON.stringify(commonTagList));
        _commonTagList = _commonTagList.map((v: any) => { return {
            ...v, active: false
        }})
        setCommonTagList(_commonTagList);
    }

    const setOrginAlkTags = () => {
        let _alkTagList: any = JSON.parse(JSON.stringify(alkTagList));
        _alkTagList = _alkTagList.map((v: any) => { return {
            ...v, active: false
        }})
        setAlkTagList(_alkTagList);
    }

    const getCommonTags = () => {
        setOrginCommonTags();
        setIsCommonTag(true);
        initLists();
    }

    const getAlkTags = () => {
        setIsCommonTag(false);
        getAlkList({});
        if (alkTagList.length > 0) {
            setOrginAlkTags();
            return;
        }
        api.getQuestionnaireAlkConfig().then((res: any) => {
            if (res.code == 0) {
                setAlkTagList(res.data || []);
            }
        })
    }

    const getAlkList = (val: any) => {
        const _mParam: any = {};
        if (val && val.code) {
            _mParam.symptomCode = val.code;
        }
        api.getQuestionnaireAlkList(_mParam).then((res: any) => {
            if (res.code == 0) {
                setQuestionnaireList(res.data || {});
            }
        })
    }

    const clickItem = (v: any) => {
        if (v.code && v.countNum) {
            setIsCommonTag(true);
            initLists({
                symptomCode: v.code
            });
            let _list =JSON.parse(JSON.stringify(commonTagList));
            let hasBefore = false;
            _list = _list.map((val: any) => {
                if (v.code == val.code) {
                    hasBefore = true;
                    return {
                        ...val,
                        active: true,
                        bothHas: true
                    }
                }  else {
                    return {
                        ...val,
                        active: false
                    }
                }
            });
            if (!hasBefore) {
                _list = _list.filter((v: any) => !v.isMore)
                // 从弹框里选中来的
                _list.unshift({ ...v, active: true, isMore: true })
            }
            setCommonTagList(_list);
            setVisible(false);
        }
    }

    const tagsActive = (v: any, index: number) => {
        if (isCommonTag) {
            const _commonTagList: any = JSON.parse(JSON.stringify(commonTagList));
            const _curActive = !v.active;
            const _param = _curActive ? {
                symptomCode: v.code
            } : {};
            initLists(_param);
            // _commonTagList[index] = {
            //     ..._commonTagList[index],
            //     active: true
            // }
            const _list = _commonTagList.map((val: any, key: number) => {
                if (key == index) {
                    const _active = !val.active;
                    return {
                        ...val,
                        active: _active
                    }
                }  else {
                    return {
                        ...val,
                        active: false
                    }
                }
            })
            setCommonTagList(_list);
        } else {
            const _alkTagList: any = JSON.parse(JSON.stringify(alkTagList));
            const _curActive = !v.active;
            const _param = _curActive ? v : {};
            getAlkList(_param);
            // _alkTagList[index] = {
            //     ..._alkTagList[index],
            //     active: true
            // }
            const _list = _alkTagList.map((val: any, key: number) => {
                if (key == index) {
                    const _active = !val.active;
                    return {
                        ...val,
                        active: _active
                    }
                }  else {
                    return {
                        ...val,
                        active: false
                    }
                }
            })
            setAlkTagList(_list);
        }
    }

    const checkAuthor = () => {
        if(Number(shoppingParams.type) === 3) {
            (window as any).wx.miniProgram.navigateTo({url: `/pages/aeAuthor/aeAuthor`})
            props.authorOpen && props.authorOpen()
            return true
        }
    }

    const scaleStart = (val: any) => {
        // const formData = props.aeScale || sessionStorage.getItem('AeScale');
        if(checkAuthor()) return
        const formData = {
            crfCode: val.scaleCode
        }
        sessionStorage.setItem('AeScaleFormData', JSON.stringify(formData));
        props.history.push(`/alk/scale?code=${val.code}`);
    }

    return (
        <div className={styles.testTools_container}>
            <img className={styles.testBanner} src={tool_top_banner} alt="" />
            {
                false &&
                <div className={styles.top_nav}>
                    <div className={`${styles.top_nav1} ${isCommonTag ? styles.active_nav : ''}`} onClick={getCommonTags}>
                        常见症状
                        {
                            isCommonTag &&
                            <div className={styles.border}></div>
                        }
                    </div>
                    <div className={`${styles.top_nav2} ${isCommonTag ? '' : styles.active_nav}`} onClick={getAlkTags}>
                        ALK风险症状
                        {
                            !isCommonTag &&
                            <div className={styles.border}></div>
                        }
                    </div>
                    <div className={styles.top_nav3}></div>
                    {/* <div className={styles.top_nav4}
                        onClick={() => {
                            setVisible(true)
                        }}
                    >
                        <div>
                            <div>全部</div>
                            <div>症状</div>
                        </div>
                        <img src={icon_more} alt="" />
                    </div> */}
                </div>
            }
            <div className={styles.middle_nav_wrap}>
                <div className={styles.middle_nav} id="edc_wechat_alk_tool_nav_scroll">
                {
                    ((isCommonTag ? commonTagList : alkTagList) || []).map((v: any, k: number) => (
                        <div key={k} className={v.active ? styles.active : ''} 
                            id={v.active ? 'edc_wechat_alk_tool_nav' : ''}
                            onClick={() => { tagsActive(v, k) }}>
                            {v.name}{v.countNum ? ` (${v.countNum})` : ''}
                        </div>
                    ))
                }
                </div>
                <div className={styles.icon_right}
                    onClick={() => {
                        setVisible(true)
                    }}
                >
                    <div>
                        {
                            !dialogHasSelected ?
                            <>
                               <div>全部</div>
                                <div>症状</div>
                            </>
                            :
                            <>
                               <div>已经</div>
                                <div>筛选</div>
                            </>
                        }
                    </div>
                    <img src={icon_more} alt="" />
                </div>
            </div>
            <div className={styles.content}>
                <div className={styles.scale_list}>
                    {
                        inType && questionnaireTypeList.map((vv: any, ii: number) => (
                            <div key={ii}>
                                <div className={ii != 0 ? `${styles.type_title} ${styles.in_title}` : styles.in_title}>
                                    <img src={icon_medicine} alt="" />
                                    {vv[0]?.typeName}
                                </div>
                                <div className={styles.scale_list_second} >
                                    { vv.map((v: any, i: number) => (
                                    <div className={v.completedState == 1 ? styles.scale : `${styles.scale} ${styles.completed}`} key={i}>
                                        <div className={styles.scale_name}>{v.cname}</div>
                                        <div className={styles.scale_code}>{v.ename}</div>
                                        <div className={styles.scale_info}>
                                            <span className={styles.icon}></span>
                                            {/* <span>{v.tip}</span> */}
                                            <span>{`${v.topicNum}题 / 约${v.useTime}分钟`}</span>
                                        </div>
                                        <div className={styles.scale_btn} onClick={ () => { scaleStart(v); }}>
                                            {v.completedState == 0 ? '开始测评' : '重新测评'}
                                        </div>
                                        <div className={styles.tip}>
                                            {
                                                v.completedState == 0 ? 
                                                <span>
                                                    未测评
                                                    <span className={styles.inner}>
                                                        {v.cycleType == 1 ? '( 建议一周一次 )' : v.cycleType == 2 ? '( 建议一月一次 )' : null}
                                                    </span>
                                                </span>
                                                : 
                                                <span>
                                                    {/* 历史评测 */}
                                                    <span className={styles.inner}>
                                                        {v.cycleType == 1 ? '( 本周已测 )' : v.cycleType == 2 ? '( 本月已测 )' : null}
                                                    </span>
                                                </span>
                                            }
                                            {v.completedState == 0 && <img className={styles.pencil} src={tool_purple_pencil} alt="" />}
                                            {/* {v.completedState == 1 && <img className={styles.more_arrow} src={More} alt="" />} */}
                                        </div>
                                    </div>
                                    ))
                                    }
                                </div>
                            </div>
                        ))
                    }
                    {
                        !inType && questionnaireList && questionnaireList.map((v: any, i: number) => (
                            <div className={v.completedState == 1 ? styles.scale : `${styles.scale} ${styles.completed}`} key={i}>
                                <div className={styles.scale_name}>{v.cname}</div>
                                <div className={styles.scale_code}>{v.ename}</div>
                                <div className={styles.scale_info}>
                                    <span className={styles.icon}></span>
                                    {/* <span>{v.tip}</span> */}
                                    <span>{`${v.topicNum}题 / 约${v.useTime}分钟`}</span>
                                </div>
                                <div className={styles.scale_btn} onClick={ () => { scaleStart(v); }}>
                                    {v.completedState == 0 ? '开始测评' : '重新测评'}
                                </div>
                                <div className={styles.tip}>
                                    {
                                        v.completedState == 0 ? 
                                        <span>
                                            未测评
                                            <span className={styles.inner}>
                                                {v.cycleType == 1 ? '( 建议一周一次 )' : v.cycleType == 2 ? '( 建议一月一次 )' : null}
                                            </span>
                                        </span>
                                        : 
                                        <span>
                                            {/* 历史评测 */}
                                            <span className={styles.inner}>
                                                {v.cycleType == 1 ? '( 本周已测 )' : v.cycleType == 2 ? '( 本月已测 )' : null}
                                            </span>
                                        </span>
                                    }
                                    {v.completedState == 0 && <img className={styles.pencil} src={tool_purple_pencil} alt="" />}
                                    {/* {v.completedState == 1 && <img className={styles.more_arrow} src={More} alt="" />} */}
                                </div>
                            </div>
                        ))
                    }
                    { listReady && questionnaireList && questionnaireList.length == 0 &&
                        <div className={styles.no_result}>
                            <img src={no_result} alt="" />
                        </div>
                    }
                </div>
            </div>
            <Popup
              visible={visible}
              position='top'
              onMaskClick={() => {
                setVisible(false)
              }}
              bodyStyle={{ height: '80vh', overflow: 'auto', borderBottomLeftRadius: '15px', borderBottomRightRadius: '15px' }}
            >
                <div className={styles.position_wrap}>
                {
                    (tagList || []).map((val: any, index: number) => (
                        <div className={styles.position} key={index}>
                            <div className={styles.position_name}>{val[0].positionName}</div>
                            <div className={styles.organ_item_wrap}>
                            {
                                (val || []).map((v: any, k: number) => (
                                    <div className={`${styles.organ_item} ${v.countNum ? '' : styles.un_active}`} key={k}
                                         onClick={() => { clickItem(v) }}
                                    >
                                        {v.name}
                                    </div>
                                ))
                            }
                            </div>
                        </div>
                    ))
                }
                </div>
            </Popup>
        </div>
    )
}

export default withRouter(AeTestTools);